module.exports = __webpack_public_path__ + "img/INVOICE.cd78c8b2.svg";